import React from 'react';
import userSetAction from '../../actions/userSetAction';

class ModalCondo extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.state = {
            txtValue1: "",
            txtValue2: "",
            txtValue3: "",
            txtValue4: "",
            txtValue5: "",
            txtValue6: "",
            txtValue7: "",
            txtValue8: 0,
            warningMsg: "",
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
        statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],
    };

    componentDidMount() {
        if (this.props.action == 3) {
            let condoIndex = this.findIndex();
            this.setState({
                txtValue1: this.props.contracts[condoIndex].contract[this.props.index].service,
                txtValue2: this.props.contracts[condoIndex].contract[this.props.index].description,
                txtValue3: this.props.contracts[condoIndex].contract[this.props.index].remark,
                txtValue4: this.props.contracts[condoIndex].contract[this.props.index].amount,
                txtValue5: this.props.contracts[condoIndex].contract[this.props.index].contractStartDate,
                txtValue6: this.props.contracts[condoIndex].contract[this.props.index].contractEndDate,
                txtValue7: this.props.contracts[condoIndex].contract[this.props.index].lastVisit,
                txtValue8: this.props.contracts[condoIndex].contract[this.props.index].status,
                warningMsg: ""
            });
        } else {
            this.setState({
                txtValue1: "",
                txtValue2: "",
                txtValue3: "",
                txtValue4: "",
                txtValue5: "",
                txtValue6: "",
                txtValue7: "",
                txtValue8: 0,
                warningMsg: "",
            });
        }
    }
    componentWillUnmount() {

    }
    findIndex() {
        let len = this.props.contracts.length;
        let pos;
        for (let i = 0; i < len; i++) {
            if (this.props.contracts[i].mcst == this.props.mcst) {
                pos = i;
                break;
            }
        }
        return pos;
    }
    handleClick(e) {
        if (this.props.action == 0) {
            if (this.checkRepeat()) return;
            if (this.state.txtValue1 == '') return this.setState({ warningMsg: "Please select condo" });
        } else if (this.props.action == 1 || this.props.action == 3) {
            if (this.checkEmpty()) return;
        }

        this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.txtValue3, this.state.txtValue4,
            this.state.txtValue5, this.state.txtValue6, this.state.txtValue7, this.state.txtValue8);
    }
    modalClose() {

        this.props.shouldModalClose(false);
    }
    checkRepeat() {
        let { contracts } = this.props;
        let len = contracts.length;
        let isRepeat = false;
        for (let i = 0; i < len; i++) {
            if (contracts[i].mcst == this.state.txtValue1) {
                isRepeat = true;
                this.setState({ warningMsg: "The selected condo has been added. Not necessary to add new one" });
                break;
            }
        }
        return isRepeat;
    }
    checkEmpty() {
        let isEmpty = false;
        if (this.state.txtValue1 == "") {
            isEmpty = true;
            this.setState({ warningMsg: "Service cannot be emptied" });
        }
        return isEmpty;
    }
    findCondoName(value) {
        let len = this.props.condos.length;
        let condoName = "";
        for (let i = 0; i < len; i++) {
            if (this.props.condos[i].mcst == value) {
                condoName = this.props.condos[i].condoName;
                break;
            }
        }
        return condoName;
    }
    handleEdit(e) {
        let index, value, condoName;
        if (this.props.action == 0) {
            value = e.target.value;
            condoName = this.findCondoName(value);
            this.setState({ txtValue1: value, txtValue2: condoName });
        } else if (this.props.action == 1 || this.props.action == 3) {
            index = parseInt(e.target.getAttribute('data-index'));
            value = e.target.value;
            if (index == 0) {
                this.setState({ txtValue1: value });
            } else if (index == 1) {
                this.setState({ txtValue2: value });
            } else if (index == 2) {
                this.setState({ txtValue3: value });
            } else if (index == 3) {
                this.setState({ txtValue4: parseFloat(value) });
            } else if (index == 4) {
                this.setState({ txtValue5: value ? new Date(value) : "" });
            } else if (index == 5) {
                this.setState({ txtValue6: value ? new Date(value) : "" });
            } else if (index == 6) {
                this.setState({ txtValue7: value ? new Date(value) : "" });
            } else if (index == 7) {
                this.setState({ txtValue8: parseInt(value) });
            }
        }
    }
    renderCondoList() {
        return this.props.condos.map((condo, index) => {
            return (<option value={condo.mcst} key={index}>{condo.condoName} ({condo.mcst})</option>);
        });
    }
    renderContent() {
        let body = "";
        let { action } = this.props;
        if (action == 0) {
            body = (
                <select className="form-control" data-index="0" onChange={this.handleEdit}>
                    <option value=""></option>
                    {this.renderCondoList()}
                </select>
            );
        } else if (action == 1) {

            let contractStartDate = "", contractEndDate = "", lastVisit = "";
            let { txtValue5, txtValue6, txtValue7 } = this.state;
            if (txtValue5) {
                contractStartDate = txtValue5.getFullYear() + "-" +
                    (txtValue5.getMonth() + 1 < 10 ? "0" + (txtValue5.getMonth() + 1) : txtValue5.getMonth() + 1) + "-" +
                    (txtValue5.getDate() < 10 ? "0" + txtValue5.getDate() : txtValue5.getDate());
            }
            if (txtValue6) {
                contractEndDate = txtValue6.getFullYear() + "-" +
                    (txtValue6.getMonth() + 1 < 10 ? "0" + (txtValue6.getMonth() + 1) : txtValue6.getMonth() + 1) + "-" +
                    (txtValue6.getDate() < 10 ? "0" + txtValue6.getDate() : txtValue6.getDate());
            }
            if (txtValue7) {
                lastVisit = txtValue7.getFullYear() + "-" +
                    (txtValue7.getMonth() + 1 < 10 ? "0" + (txtValue7.getMonth() + 1) : txtValue7.getMonth() + 1) + "-" +
                    (txtValue7.getDate() < 10 ? "0" + txtValue7.getDate() : txtValue7.getDate());
            }

            body = (
                <div>
                    <div className="form-group">
                        <label htmlFor="mService">Service</label>
                        <input type="text" className="form-control" value={this.state.txtValue1} id="mService"
                            data-index="0" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mDescription">Description</label>
                        <input type="text" className="form-control" value={this.state.txtValue2} id="mDescription"
                            data-index="1" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mLastVisit">Last Visit</label>
                        <input type="date" className="form-control" value={lastVisit} id="mLastVisit"
                            data-index="6" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mStatus">Status</label>
                        <select className="form-control" id="status" data-index="7" value={this.state.txtValue8} onChange={this.handleEdit}>
                            {this.renderStatusOption()}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="mRemark">Remark</label>
                        <input type="text" className="form-control" value={this.state.txtValue3} id="mRemark"
                            data-index="2" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mRemark">Contract Start Date</label>
                        <input type="date" className="form-control" value={contractStartDate} id="mRemark"
                            data-index="4" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mRemark">Contract End Date</label>
                        <input type="date" className="form-control" value={contractEndDate} id="mRemark"
                            data-index="5" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mAmount">Amount (SGD)</label>
                        <input ttype="number" className="form-control" value={this.state.txtValue4} id="mAmount"
                            data-index="3" onChange={this.handleEdit} />
                    </div>
                </div>
            )
        } else if (action == 2) {
            body = (<div>This contractor will be removed from this condo. Are you sure? </div>);
        } else if (action == 3) {
            let contractStartDate = "", contractEndDate = "", lastVisit = "";
            let { txtValue5, txtValue6, txtValue7 } = this.state;
            if (txtValue5) {
                txtValue5 = new Date(txtValue5);
                contractStartDate = txtValue5.getFullYear() + "-" +
                    (txtValue5.getMonth() + 1 < 10 ? "0" + (txtValue5.getMonth() + 1) : txtValue5.getMonth() + 1) + "-" +
                    (txtValue5.getDate() < 10 ? "0" + txtValue5.getDate() : txtValue5.getDate());
            }
            if (txtValue6) {
                txtValue6 = new Date(txtValue6);
                contractEndDate = txtValue6.getFullYear() + "-" +
                    (txtValue6.getMonth() + 1 < 10 ? "0" + (txtValue6.getMonth() + 1) : txtValue6.getMonth() + 1) + "-" +
                    (txtValue6.getDate() < 10 ? "0" + txtValue6.getDate() : txtValue6.getDate());
            }
            if (txtValue7) {
                txtValue7 = new Date(txtValue7);
                lastVisit = txtValue7.getFullYear() + "-" +
                    (txtValue7.getMonth() + 1 < 10 ? "0" + (txtValue7.getMonth() + 1) : txtValue7.getMonth() + 1) + "-" +
                    (txtValue7.getDate() < 10 ? "0" + txtValue7.getDate() : txtValue7.getDate());
            }
            body = (
                <div>
                    <div className="form-group">
                        <label htmlFor="mService">Service</label>
                        <input type="text" className="form-control" value={this.state.txtValue1} id="mService"
                            data-index="0" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mDescription">Description</label>
                        <input type="text" className="form-control" value={this.state.txtValue2} id="mDescription"
                            data-index="1" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mLastVisit">Last Visit</label>
                        <input type="date" className="form-control" value={lastVisit} id="mLastVisit"
                            data-index="6" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mStatus">Status</label>
                        <select className="form-control" id="status" data-index="7" value={this.state.txtValue8} onChange={this.handleEdit}>
                            {this.renderStatusOption()}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="mRemark">Remark</label>
                        <input type="text" className="form-control" value={this.state.txtValue3} id="mRemark"
                            data-index="2" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mRemark">Contract Start Date</label>
                        <input type="date" className="form-control" value={contractStartDate} id="mRemark"
                            data-index="4" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mRemark">Contract End Date</label>
                        <input type="date" className="form-control" value={contractEndDate} id="mRemark"
                            data-index="5" onChange={this.handleEdit} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mAmount">Amount (SGD)</label>
                        <input type="number" className="form-control" value={this.state.txtValue4} id="mAmount"
                            data-index="3" onChange={this.handleEdit} />
                    </div>
                </div>
            )
        } else {
            body = (<div>Are you sure to remove this services?</div>);
        }
        return body;
    }
    renderStatusOption() {
        return this.props.statusTxt.map((status, index) => {
            return (
                <option value={index} key={index}>{status}</option>
            );
        });
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        let btnTxt = "";

        if (this.props.action == 0) {
            btnTxt = "Add Estate";
        } else if (this.props.action == 1) {
            btnTxt = "Add Service";
        } else if (this.props.action == 2) {
            btnTxt = "Remove Estate";
        } else if (this.props.action == 3) {
            btnTxt = "Edit";
        } else {
            btnTxt = "Remove Service";
        }

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body" >
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn " + (this.props.action == 2 || this.props.action == 4 ? "btn-danger" : "btn-warning")}
                            onClick={this.handleClick}>{btnTxt}</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default ModalCondo;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/modalCondo.js